module.exports = __webpack_public_path__ + "static/media/florin_lazarescu.2097678b.png";